import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DocumentationCollection = function DocumentationCollection(props) {
  return /*#__PURE__*/ _jsxs(
    "svg",
    _extends(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
      },
      props,
      {
        children: [
          /*#__PURE__*/ _jsx("path", {
            fill: "transparent",
            fillOpacity: 0.01,
            d: "M17.185 2.48511H7.805C6.145 2.48511 4.805 3.82511 4.805 5.48511V18.5151C4.805 20.1751 6.145 21.5151 7.805 21.5151H15.185C16.285 21.5151 17.185 20.6151 17.185 19.5151V2.48511ZM17.185 2.48511H19.985C21.065 2.48511 21.935 3.18511 21.935 4.04511V6.11511C21.935 6.82511 21.515 7.48511 20.815 7.91511L17.185 10.0951V2.48511ZM2.065 6.29511H7.775M2.065 10.0951H7.775M2.065 13.9051H7.775M2.065 17.7051H7.775M20.995 8.19511V12.1651C20.995 12.8751 20.555 13.5351 19.795 13.9651L17.185 15.1951",
          }),
          /*#__PURE__*/ _jsx("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M17.185 2.48511H7.805C6.145 2.48511 4.805 3.82511 4.805 5.48511V18.5151C4.805 20.1751 6.145 21.5151 7.805 21.5151H15.185C16.285 21.5151 17.185 20.6151 17.185 19.5151V2.48511ZM17.185 2.48511H19.985C21.065 2.48511 21.935 3.18511 21.935 4.04511V6.11511C21.935 6.82511 21.515 7.48511 20.815 7.91511L17.185 10.0951V2.48511ZM2.065 6.29511H7.775M2.065 10.0951H7.775M2.065 13.9051H7.775M2.065 17.7051H7.775M20.995 8.19511V12.1651C20.995 12.8751 20.555 13.5351 19.795 13.9651L17.185 15.1951",
          }),
        ],
      }
    )
  );
};
export default DocumentationCollection;

